const MODULES = {
  MEETINGS: 'MEETINGS',
  GOALS: 'GOALS',
  REVIEWS: 'REVIEWS',
  SURVEYS: 'SURVEYS',
  RECOGNITIONS: 'RECOGNITIONS',
  FEEDBACK: 'FEEDBACK',
  TASKS: 'TASKS',
  NOTES: 'NOTES',
  GENERAL: 'GENERAL',
  LICENSE: 'LICENSE',
  INDIVIDUAL_DEVELOPMENT_PLAN: 'INDIVIDUAL_DEVELOPMENT_PLAN',
  NOTIFICATIONS: 'NOTIFICATIONS',
  SUCCESSION_PLAN: 'SUCCESSION_PLAN',
  LEARNING_MATERIALS: 'LEARNING_MATERIALS',
  ROLES: 'ROLES',
  COMPETENCY_LIBRARY: 'COMPETENCY_LIBRARY',
  MY_ORGANIZATION: 'MY_ORGANIZATION',
  EXTERNAL_API: 'EXTERNAL_API',
  HRIS_INTEGRATION: 'HRIS_INTEGRATION',
  BRANDING: 'BRANDING',
  AI: 'AI',
  AGENT: 'AGENT',
  MCP: 'MCP',
  FINE_TUNE_AI: 'FINE_TUNE_AI',
  GOAL_POWERBI_INTEGRATION: 'GOAL_POWERBI_INTEGRATION',
  POWERBI_TEAM_INSIGHT: 'POWERBI_TEAM_INSIGHT',
  REWARD_CARD: 'REWARD_CARD',
  NINE_BOX_CUSTOMIZATION: 'NINE_BOX_CUSTOMIZATION',
  EDIT_USER_ATTRIBUTES: 'EDIT_USER_ATTRIBUTES'
}

export { MODULES }
